import {ServiceWorkerModule} from "@angular/service-worker";
import {APP_ID, Inject, NgModule, PLATFORM_ID} from "@angular/core";
import {FlexSpinnerModule} from "@app/flex-spinner/flex-spinner.module";
import {MatSelectModule} from "@angular/material/select";
import {FlexPrintModule} from "@app/directive/flex-print/flex-print.module";
import {LoginModule} from "@app/login/login.module";
import {isPlatformBrowser} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {BrowserModule} from "@angular/platform-browser";
import {GlobalSpinnerService} from "@app/services/misc-services/global-spinner.service";
import {AppRoutingModule} from "@app/app.routing.module";
import {ErrorHandlingService} from "@app/services/misc-services/error-handling.service";
import {AppComponent} from "@app/app.component";
import {MatCardModule} from "@angular/material/card";
import {GoogleChartsModule} from "angular-google-charts";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {HttpClientModule} from "@angular/common/http";
import {MatButtonModule} from "@angular/material/button";
import {environment} from "@env/environment";
import {SigninModule} from "@app/pages/signin/signin.module";
import {FooterModule} from "@app/pages/footer/footer.module";
import {HeaderModule} from "@app/pages/header/header.module";
import {NewsModule} from "@app/pages/news/news.module";
import {AdminModule} from "@app/pages/admin/admin.module";
import {FilterPipeModule} from "@app/pipes/filter/filter-pipe.module";
import {LogPipeModule} from "@app/pipes/log/log-pipe.module";
import {OrderByModule} from "@app/pipes/order-by/order-by.module";
import {TicketsModule} from "@app/pages/tickets/tickets.module";
import {MatInputModule} from "@angular/material/input";
import {MatFormFieldModule} from "@angular/material/form-field";
import {ConfirmDialogModule} from "@app/pages/tickets/new-ticket/confirm-dialog/confirm-dialog.module";
import {DocumentsModule} from "@app/pages/documents/documents.module";
import {DeploymentsModule} from "@app/pages/deployments/deployments.module";
import {NavFilterPipeModule} from "./pipes/nav-filter/nav-filter-pipe.module";
import {NgxEditorModule} from "ngx-editor";
import {CreditUnionModule} from "@app/services/credit-union/credit-union.module";
import {LogsModule} from "@app/pages/logs/logs.module";
import {FormatDatePipeModule} from "@app/pipes/format-date/format-date-pipe.module";
import {DashboardDataModule} from "@app/services/dashboard-data/dashboard-data.module";
import {DashboardModule} from "@app/pages/dashboard/dashboard.module";
import {HraModule} from "@app/pages/tickets/hra/hra.module";
import {NewTicketModule} from "@app/pages/tickets/new-ticket/new-ticket.module";
import {ConfirmationDialogService} from "@app/commons/confirmation-dialog/confirmation-dialog.service";
import {ConfirmationDialogModule} from "@app/commons/confirmation-dialog/confirmation-dialog.module";
import {UserModule} from "@app/pages/user/user.module";
import {TicketViewModule} from "@app/pages/tickets/ticket-view/ticket-view.module";


@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserModule.withServerTransition({appId: 'portal'}),
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        HttpClientModule,
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
        MatCardModule,
        GoogleChartsModule,
        MatSelectModule,
        FilterPipeModule,
        LoginModule,
        MatButtonModule,
        FlexSpinnerModule,
        FlexPrintModule,
        SigninModule,
        FooterModule,
        HeaderModule,
        NewsModule,
        AdminModule,
        OrderByModule,
        LogPipeModule,
        TicketsModule,
        NewTicketModule,
        MatSnackBarModule,
        MatInputModule,
        MatFormFieldModule,
        ConfirmDialogModule,
        DocumentsModule,
        MatFormFieldModule,
        NavFilterPipeModule,
        NgxEditorModule,
        CreditUnionModule,
        NgxEditorModule,
        DeploymentsModule,
        LogsModule,
        FormatDatePipeModule,
        DashboardDataModule,
        DashboardModule,
        HraModule,
        ConfirmationDialogModule,
        UserModule,
        TicketViewModule
    ],
    providers: [GlobalSpinnerService, ErrorHandlingService, ConfirmationDialogService],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(@Inject(PLATFORM_ID) public platformId: Object, @Inject(APP_ID) public appId: string) {
        const platform = isPlatformBrowser(platformId) ? 'in the browser' : 'on the server';
        console.log(`Running ${platform} with appId=${appId}`);
    }
}
